import * as React from 'react';
import { StyledBoxedMessage } from './elements/boxedMessage/StyledBoxedMessage';
import { isNilOrEmpty } from '../language/module';
import { BoxedMessageStyle } from './elements/boxedMessage/boxedMessageStyle';
import { BoxedErrorMessageDefault } from './elements/boxedMessage/boxedMessageStyles';
import ClamShell from '../layout/ClamShell';
import { SerializedStyles } from '@emotion/react';


/**
 * ErrorView: a component that collapses/expands an error view depending on whether or not its error prop has a value.
 * Removes form margin when no error so as to take up no space.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class ErrorView extends React.PureComponent<{
  error: string | undefined;
  boxStyle?: BoxedMessageStyle,
  rootCss?: SerializedStyles;
}> {
  public static defaultProps = {
    boxStyle: BoxedErrorMessageDefault,
  };


  public render = () => (
    <ClamShell isOpen={!isNilOrEmpty(this.props.error)}
               rootCss={this.props.rootCss}>
      <StyledBoxedMessage boxStyle={this.props.boxStyle} message={this.props.error || ''}/>
    </ClamShell>
  );
}
